"use strict";

// requires NodeList.forEach polyfill for IE
require('nodelist-foreach-polyfill');

var ActiveDescendant = require('../../index.js');

var navs = [];
var appender = document.getElementById('appender');
var widgetEls = document.querySelectorAll('.widget');
var wrapCheckbox = document.getElementById('wrap');
appender.addEventListener('click', function () {
  widgetEls.forEach(function (el) {
    var list = el.querySelector('ul');
    var newListItem = document.createElement('li');
    newListItem.setAttribute('role', 'option');
    var numListItems = parseInt(list.querySelectorAll('li').length, 10);
    newListItem.innerText = "Item ".concat(numListItems);
    list.appendChild(newListItem);
  });
});
widgetEls.forEach(function (el) {
  el.addEventListener('activeDescendantChange', function (e) {
    console.log(e);
  });
  var options = {
    useAriaSelected: false
  };

  if (el.dataset.makeupInit !== undefined) {
    options.autoInit = el.dataset.makeupInit;
  }

  if (el.dataset.makeupReset !== undefined) {
    if (el.dataset.makeupReset === 'null') {
      options.autoReset = null;
    } else {
      options.autoReset = el.dataset.makeupReset;
    }
  }

  var widget = ActiveDescendant.createLinear(el, el.querySelector('input') || el.querySelector('ul'), el.querySelector('ul'), 'li', options);
  navs.push(widget);
});
wrapCheckbox.addEventListener('change', function (e) {
  navs[0].wrap = e.target.checked;
});
